module.exports = __webpack_public_path__ + "static/media/BOT-2.b94fa4d6.png";